<template>
    <div class="container mb-5">

        <div class="k-tabs">
            <ul class="k-tabs__list">
                <li @click="tabChanged('myDocuments')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'myDocuments'}]"><a href="javascript:;" class="k-tabs__link">Moje dokumenty ({{ myDocumentsCount }})</a></li>
                <li @click="tabChanged('watchingDocuments')" class="k-tabs__item" :class="[{'k-tabs__item--active' : activeTab === 'watchingDocuments'}]"><a href="javascript:;" class="k-tabs__link ">Sledované dokumenty ({{ watchingDocumentsCount }})</a></li>
            </ul>

            <div class="k-tabs__actions">
                <a :href="DocumentsListLink" class="k-tabs__actions-link">
                    Dokumenty
                    <svg class="k-tabs__actions-icon k-tabs__actions-icon--after" role="img" width="15" height="15">
                        <use fill="currentColor" xlink:href="/images/spritesheet.svg#arrow-right"/>
                    </svg>
                </a>
            </div>
        </div>

        <transition-group name="list-complete" tag="div" class="k-table">
            <div v-for="document in documents.data" :key="document.id" class="k-table__row">
                <div class="k-table__cell">
                    <div class="k-file-meta k-mr-20">
                        <svg class="k-file-meta__icon" role="img" width="24" height="25">
                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#file-pdf"/>
                        </svg>

                        <div class="k-file-meta__text">
                            {{ document.size_formatted }}
                        </div>
                    </div>

                    <div class="mr-auto" >
                        <a  :href="document.detail_url" class="mb-1 d-block">
                            <strong class="k-strong">
                                {{ document.title }}
                            </strong>
                        </a>

                        <div class="k-table__cell-meta ml-0">
                            <a v-for="(url, title) in document.categories" class="k-link mr-2" :href="url">{{ title }}</a>
                        </div>
                    </div>

                    <span v-if="document.status && document.status!== null" class="k-table__cell-meta k-label" :class="document.status.class">
                        {{ document.status.text }}
                    </span>

                    <span class="k-table__cell-meta">{{ document.created_at }}</span>

                </div>

                <div class="k-table__cell k-table__cell--action">
                    <a :href="document.detail_url" class="k-action k-action--control">
                        <svg class="k-action__icon" role="img" width="15" height="15">
                            <use fill="currentColor" xlink:href="/images/spritesheet.svg#eye"/>
                        </svg>
                        Zobrazit
                    </a>
                </div>

                <div class="k-table__cell k-table__cell--action">
                    <template v-if="document.zip_url !== null">
                        <a :href="document.zip_url" class="k-action k-action--control">
                            <svg class="k-action__icon" role="img" width="15" height="15">
                                <use fill="currentColor" xlink:href="/images/spritesheet.svg#download"/>
                            </svg>
                            Stáhnout
                        </a>
                    </template>
                    <template v-else>
                        <strong>Zpracovávám</strong>
                    </template>
                </div>
            </div>
            <div key="0" v-if="documents.data && documents.data.length === 0" class="k-table__cell p-3">
                Nebyly nalezeny žádné dokumenty.
            </div>
        </transition-group>

        <pagination class="mt-5" :data="documents" @pagination-change-page="getData" :limit="2"></pagination>

    </div>
</template>

<script>
    import Pagination from 'laravel-vue-pagination';

    export default {
        components: {
            'pagination': Pagination
        },

        props: {
            /**
             * Data url
             */
            url: {
                type: String,
                required: true
            },
            myDocumentsCount: {
                type: Number,
                default: 0
            },
            watchingDocumentsCount: {
                type: Number,
                default: 0
            }
        },

        data: () => ({
            documents: {},
            activeTab: 'myDocuments'
        }),

        computed: {
            /**
             * Get documents list link
             *
             * @return string
             */
            DocumentsListLink: function() {
                return Links.documentsList;
            }
        },

        methods: {
            /**
             * Get data
             *
             * @returns void
             */
            getData: async function(page = 1) {
                try{
                    let result = await axios({
                        method: 'GET',
                        url: this.url,
                        params: {
                            page: page,
                            filter: this.activeTab,
                            showStatus: this.activeTab === 'myDocuments' ? 1 : 0
                        }
                    });
                    if (result.status === 200 && result.data) {
                        this.documents = result.data;
                    }
                }
                catch (e) {
                    console.log(e.message);
                }
            },

            /**
             * Tab changed
             *
             * @returns void
             */
            tabChanged: function(value) {
                if (this.activeTab !== value) {
                    this.activeTab = value;
                    // get data and keep current page
                    this.getData();
                }
            }
        },

        mounted() {
            this.getData();
        }
    }
</script>

<style scoped>
    .list-complete-enter, .list-complete-leave-to {
        opacity: 0;
    }

    .list-complete-leave {
        transition: opacity .5s;
    }

    .list-complete-enter-to {
        transition: opacity 1.5s;
    }
</style>
